import { SparklesIcon } from "lucide-react";

export const DescriptionAiRebalance = () => {
    return (
        <div className="min-w-0">
            <div className="mb-2 flex items-center gap-2">
                <span
                    className="inline-flex items-center justify-center w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-primary/90 rounded-md border border-border bg-white px-2 py-1 text-[11px] font-medium text-primary shadow-none"
                >
                    <SparklesIcon className="!h-4 !w-4" />
                    <span>Governed Recommendations</span>
                </span>
            </div>
            <h2 className="text-lg font-semibold tracking-[-0.02em] text-primary">
                AI Rebalance
            </h2>
            <p className="mt-1 max-w-2xl text-sm text-gray-600">
                A compact governed queue for reviewing demand assumptions first, then actioning SKU-level rebalance proposals without leaving excess empty space in the workspace.
            </p>
        </div>
    );
};
